import { useEffect, useState, useCallback, useRef } from "react";
import { ChevronLeft } from "lucide-react";
import axios from 'axios';
// import * as API_END_POINT from '../../utilities/constant';
import { useSearchParams } from "react-router-dom";
import { tagGroupFilter } from "./facetGroups";
import { useStore } from "../../../context/StoreContext";
import {
    Accordion,
    Checkbox,
    Input,
    SearchInput,
    ShowMore,
    RailSkeleton,
} from "../../../shared/components";

/* THE BROWSE RAIL.

   Every control in here is a shared component now. The groups, option rows,
   price fields, brand search and reveal used to be Tailwind markup written out
   four times in this file — 16px text, an `mr-2` gap and a checkbox with no
   `accent-color`, which is why a ticked box came out browser-blue on a page
   where everything clickable is the partner's colour. `browse.css` then carried
   a "RAIL COMPATIBILITY" block restyling it from outside; both are gone, because
   the rows ARE `.br-opt`.

   The logic is untouched: toggleCategory, toggleSubCategory, toggleBrand,
   togglePriceRange and toggleTagValue still own the filter state and the URL. */

const SideFilter = ({ filters, setFilters, filtersView, setfiltersView, filterData, manualPriceRange, setManualPriceRange }) => {
    const { storeDetails } = useStore();

    const [searchParams, setSearchParams] = useSearchParams();
    // const [brandValues, setBrandValues] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [expandedCategories, setExpandedCategories] = useState({});
    // const { allCategory } = useUser();
    const [openDropdowns, setOpenDropdowns] = useState({});
    const [searchParamsCategoryIndex, setSearchParamsCategoryIndex] = useState(6);
    const [priceInput, setPriceInput] = useState({
        min: "",
        max: ""
    });
    const debounceTimeoutRef = useRef(null);
    const hasValue = (v) => v !== "" && v !== null && v !== undefined && Number.isFinite(Number(v));

    const categotyTagmap = {
        "food": ["animal_type", "life_stage_age", "specialty_diet", "size_breed", "intended_use"],
        "treats": ["animal_type", "life_stage_age", "specialty_diet", "size_breed", "intended_use"],
        "health_wellness": ["animal_type", "life_stage_age", "size_breed", "intended_use"],
        "grooming": ["animal_type", "life_stage_age", "size_breed", "intended_use"],
        "beds_home": ["animal_type", "life_stage_age", "size_breed"],
        "collars_leashes_harnesses": ["animal_type", "life_stage_age", "size_breed", "intended_use"],
        "tech": ["animal_type", "life_stage_age", "size_breed", "intended_use"],
        "feeding_supplies": ["animal_type", "life_stage_age", "size_breed"],
        "toys": ["animal_type", "life_stage_age", "size_breed", "intended_use"],
        "clothing_accessories": ["animal_type", "life_stage_age", "size_breed"],
        "travel_outdoor": ["animal_type", "life_stage_age", "size_breed"],
        "potty_waste_management": ["animal_type", "life_stage_age", "size_breed"],
        "training_behavior": ["animal_type", "life_stage_age", "size_breed", "intended_use"],
        "pet_parents": ["life_stage_age", "animal_type"]
    };

    // Remove incompatible tags and filter pills when category changes (but not during initial setup)
    useEffect(() => {
        if (filters.categories?.length > 0 && filterData?.tagGroups) {
            const allowedTags = filters.categories
                ?.map(cat => categotyTagmap[cat.category_id] || [])
                .flat();

            // Removes incompatible tags
            const updatedTags = filters.tags?.filter(tag => {
                const tagGroup = filterData?.tagGroups?.find(group => 
                    group.tags.some(t => t.code === tag)
                );
                return !tagGroup || allowedTags.includes(tagGroup.code);
            }) || [];

            if (updatedTags.length !== (filters.tags?.length || 0)) {
                setFilters(prev => ({ ...prev, tags: updatedTags }));
            }

            // Removes filter pills
            setfiltersView(prev => {
                return prev.filter(f => {
                    if (!String(f.id).startsWith("group-")) return true;
                    
                    const groupCode = f.id.replace("group-", "");
                    return allowedTags.includes(groupCode);
                });
            });

            // Updates search params
            setSearchParams(prev => {
                const params = Object.fromEntries(prev);
                filterData.tagGroups.forEach(group => {
                    if (!allowedTags.includes(group.code)) {
                        delete params[group.code];
                    }
                });
                return params;
            });
        }
    }, [filters.categories, filters.tags, filterData?.tagGroups]);

    // Clear price input when price filter is removed
    useEffect(() => {
        if (filters.priceRange?.length === 0) {
            setPriceInput({ min: "", max: "" });
        }
    }, [filters.priceRange]);

    // Sync price input with manual price range from parent
    useEffect(() => {
        if (manualPriceRange?.min !== undefined && manualPriceRange?.max !== undefined) {
            setPriceInput({
                min: manualPriceRange.min,
                max: manualPriceRange.max
            });
        }
    }, [manualPriceRange]);

    const debouncedPriceUpdate = (minVal, maxVal) => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }
        
        debounceTimeoutRef.current = setTimeout(() => {
            const priceString = `${minVal}-${maxVal}`;
            setSearchParams(prev => ({
                ...Object.fromEntries(prev),
                price: priceString,
            }));
            togglePriceRange(priceString);
        }, 500);
    };

    useEffect(() => {
        if (filters.categories?.length === 0) {
            setExpandedCategories({});
        }

    }, [filters])
    useEffect(() => {
        if (filterData?.categories) {
            const index = filterData?.categories?.findIndex(cat => cat.code === searchParams.get('category'));
            setSearchParamsCategoryIndex(index > 6 ? index + 1 : 6);
        }
    }, [filterData?.categories]);
    // useEffect(() => {

    //     if (searchParams.get('hassample')) {
    //         setOpenDropdowns({ 'samples available': true });
    //         toggleSample(true);
    //     }
    //     if (searchParams.get('category')) {
    //         // setOpenDropdowns({ category: true });
    //         // const categoryParam = searchParams.get('category');
    //         // filterData?.categories.forEach((row, index) => {
    //         //     if (row.code === categoryParam) {
    //         //         toggleCategory(index);
    //         //     }
    //         // });
    //         const timeout = setTimeout(() => {
    //             setOpenDropdowns({ category: true });
    //             const categoryParam = searchParams.get('category');
    //             filterData?.categories.forEach((row, index) => {
    //                 if (row.code === categoryParam) {
    //                     toggleCategory(index);
    //                 }
    //             });
    //         }, 700); // delay in ms (e.g., 500ms)
    //         return () => clearTimeout(timeout);
    //     }
    // }, [filterData?.categories]);

    const handlePriceInputChange = (e) => {
        const { name, value } = e.target;

        // allow only numbers
        if (value !== "" && !/^\d+$/.test(value)) return;

        setPriceInput(prev => ({
            ...prev,
            [name]: value
        }));

        if((name === 'min' && hasValue(value) && hasValue(priceInput?.max)) ||  (name === 'max' && hasValue(value) && hasValue(priceInput?.min))){
            const minVal = name === 'min' ? value : priceInput?.min;
            const maxVal = name === 'max' ? value : priceInput?.max;
            debouncedPriceUpdate(minVal, maxVal);
        } else if (!hasValue(name === 'min' ? value : priceInput?.min) && !hasValue(name === 'max' ? value : priceInput?.max)) {
            // Both fields are empty → remove price filter
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
            setSearchParams(prev => {
                const params = Object.fromEntries(prev);
                delete params.price;
                return params; 
            });
            setFilters(prev => ({ ...prev, priceRange: [] }));
            setfiltersView(prev => prev.filter(f => f.id !== 4));
        }
    };

    useEffect(() => {
        if (!filterData?.categories && !filterData?.tagGroups) return;
        
        const defaultSubCategory = searchParams.get('subcategory');
        const categoryParam = searchParams.get('category');
        const brandsParam = searchParams.get('brands');
        const vendorsParam = searchParams.get('vendors');
        const priceRangeParam = searchParams.get('price');
        const animalTypeParam = searchParams.get('animal_type');
        const lifeStageAgeParam = searchParams.get('life_stage_age');
        const specialtyDietParam = searchParams.get('specialty_diet');
        const sizeBreedParam = searchParams.get('size_breed');
        const intendedUseTypeParam = searchParams.get('intended_use');
        const brandValuesParam = searchParams.get('brand_values');
        const hassampleParam = searchParams.get('hassample');

        // Only update filters if URL params exist and don't match current state
        const shouldUpdateCategory = categoryParam && (!filters.categories?.length || filters.categories[0]?.category_id !== categoryParam);
        
        if (!shouldUpdateCategory && !brandsParam && !vendorsParam && !brandValuesParam && !hassampleParam && !animalTypeParam && !lifeStageAgeParam && !specialtyDietParam && !sizeBreedParam && !intendedUseTypeParam) {
            return;
        }

        let newOpenDropdowns = { ...openDropdowns };
        let newFilterView = [...filtersView];
        let newFilters = { ...filters };
        let newExpandedCategories = { ...expandedCategories };

        if (shouldUpdateCategory && filterData?.categories) {
            setOpenDropdowns({ category: true });
            filterData?.categories?.forEach((row, index) => {
                if (row.code === categoryParam) {
                    const {updatedCategories, categoryCode, selectedCategory, matchedSubCategorys} = prepareCategoryFilter(index, defaultSubCategory);

                    newOpenDropdowns = {
                        ...newOpenDropdowns,
                        ['category']: true,
                    }

                    newFilters = {
                        ...newFilters,
                        categories: updatedCategories,
                    }

                    newExpandedCategories = {
                        [row.code]: true,
                    };

                    if (updatedCategories.length) {
                        newFilterView = [
                            ...newFilterView.filter(
                                f => !String(f.id).startsWith("group-") && f.id !== 1
                            ),
                            {
                                id: 1,
                                label: "Category",
                                value: `${selectedCategory.name}${
                                defaultSubCategory && matchedSubCategorys?.name
                                    ? `/${matchedSubCategorys.name}`
                                    : ""
                                }`
                            }
                        ];
                    } else {
                        newFilterView = [
                            ...newFilterView.filter(
                                f => !String(f.id).startsWith("group-") && f.id !== 1
                            )
                        ];
                    }
                }
            });
        }

        if ((brandsParam || vendorsParam) && filterData?.brands) {
            const brandsParamArray = brandsParam?.split(',')?.map(item=>{
                return {
                    type: 'brand',
                    id: Number(item)
                }
            }) || [];

            const vendorsParamArray = vendorsParam?.split(',')?.map(item=>{
                return {
                    type: 'vendor',
                    id: Number(item)
                }
            }) || [];

            const {newValues, selectedBrandNames, newVendorValues, selectedVendorNames} = prepareBrandFilter([...brandsParamArray, ...vendorsParamArray]);

            newOpenDropdowns = {
                ...newOpenDropdowns,
                ['brand']: true,
            }

            newFilters = {
                ...newFilters,
                brandValues: newValues,
                vendorValues: newVendorValues,
            }

            if (newValues.length || newVendorValues.length) {
                newFilterView = [
                    ...newFilterView.filter(
                        f => !String(f.id).startsWith("group-") && f.id !== 2
                    ),
                    {
                        id: 2,
                        label: "Brand",
                        value: `${selectedBrandNames}${selectedVendorNames ?`${selectedBrandNames?.length ? `, ` :``} ${selectedVendorNames}`: ``}`
                    }
                ];
            } else {
                newFilterView = [
                    ...newFilterView.filter(
                        f => !String(f.id).startsWith("group-") && f.id !== 2
                    )
                ];
            }
        }

        if (brandValuesParam && filterData?.brandValues) {
            const {newValues, selectedBrandNames} = prepareBrandValuesFilter(brandValuesParam);

            newOpenDropdowns = {
                ...newOpenDropdowns,
                ['brand values']: true,
            }

            newFilters = {
                ...newFilters,
                brandValues: newValues,
            }

            if (newValues.length) {
                newFilterView = [
                    ...newFilterView.filter(f => f.id !== 2),
                    {
                        id: 2,
                        label: "Brand Values",
                        value: selectedBrandNames,
                    }
                ];
            } else {
                newFilterView = [
                    ...newFilterView.filter(f => f.id !== 2),
                ];
            }
        }

        if (hassampleParam && filterData?.hasSample) {
            const {newValues, finalval} = prepareSampleFilter(yesNoStringToBooleanArray(hassampleParam));
            newOpenDropdowns = {
                ...newOpenDropdowns,
                ['samples available']: true,
            }

            newFilters = {
                ...newFilters,
                sample: newValues,
            }

            if (newValues.length) {
                newFilterView = [
                    ...newFilterView.filter(f => f.id !== 3),
                    {
                        id: 3,
                        label: "Sample",
                        value: finalval,
                    }
                ];
            } else {
                newFilterView = [
                    ...newFilterView.filter(f => f.id !== 3),
                ];
            }
        }



        if (animalTypeParam && filterData?.tagGroups) {
            newOpenDropdowns = {
                ...newOpenDropdowns,
                ['animal type']: true,
            }
            const grp = filterData?.tagGroups?.find(item=>item.code==='animal_type');
            const { newValues, id, groupTagMap, selectedGroupTags } = prepareToggleTagFilter(animalTypeParam, grp);

            newFilters = {
                ...newFilters,
                tags: [...(newFilters.tags || []), ...newValues],
            }

            if (newValues.length) {
                newFilterView = [
                    ...newFilterView.filter(f => f.id !== id),
                    {
                        id: id,
                        label: grp.name,
                        value: selectedGroupTags
                        .map(code => `${groupTagMap[code]}`)
                        .join(", ")
                    },
                ];
            } else {
                newFilterView = [
                    ...newFilterView.filter(f => f.id !== id),
                ];
            }
        }

        if (lifeStageAgeParam && filterData?.tagGroups) {
            const grp = filterData?.tagGroups?.find(item=>item.code==='life_stage_age');
            const { newValues, id, groupTagMap, selectedGroupTags } = prepareToggleTagFilter(lifeStageAgeParam, grp);
            newOpenDropdowns = {
                ...newOpenDropdowns,
                ['life stage / age']: true,
            }
            newFilters = {
                ...newFilters,
                tags: [...(newFilters.tags || []), ...newValues],
            }

            if (newValues.length) {
                newFilterView = [
                    ...newFilterView.filter(f => f.id !== id),
                    {
                        id: id,
                        label: grp.name,
                        value: selectedGroupTags
                        .map(code => `${groupTagMap[code]}`)
                        .join(", ")
                    },
                ];
            } else {
                newFilterView = [
                    ...newFilterView.filter(f => f.id !== id),
                ];
            }
        }

        if (specialtyDietParam && filterData?.tagGroups) {
            const grp = filterData?.tagGroups?.find(item=>item.code==='specialty_diet');
            const { newValues, id, groupTagMap, selectedGroupTags } = prepareToggleTagFilter(specialtyDietParam, grp);

            newOpenDropdowns = {
                ...newOpenDropdowns,
                ['specialty diet']: true,
            }

            newFilters = {
                ...newFilters,
                tags: [...(newFilters.tags || []), ...newValues],
            }

            if (newValues.length) {
                newFilterView = [
                    ...newFilterView.filter(f => f.id !== id),
                    {
                        id: id,
                        label: grp.name,
                        value: selectedGroupTags
                        .map(code => `${groupTagMap[code]}`)
                        .join(", ")
                    },
                ];
            } else {
                newFilterView = [
                    ...newFilterView.filter(f => f.id !== id),
                ];
            }
        }

        if (sizeBreedParam && filterData?.tagGroups) {
            const grp = filterData?.tagGroups?.find(item=>item.code==='size_breed');
            const { newValues, id, groupTagMap, selectedGroupTags } = prepareToggleTagFilter(sizeBreedParam, grp);

            newOpenDropdowns = {
                ...newOpenDropdowns,
                ['size / breed']: true,
            }

            newFilters = {
                ...newFilters,
                tags: [...(newFilters.tags || []), ...newValues],
            }

            if (newValues.length) {
                newFilterView = [
                    ...newFilterView.filter(f => f.id !== id),
                    {
                        id: id,
                        label: grp.name,
                        value: selectedGroupTags
                        .map(code => `${groupTagMap[code]}`)
                        .join(", ")
                    },
                ];
            } else {
                newFilterView = [
                    ...newFilterView.filter(f => f.id !== id),
                ];
            }
        }

        if (intendedUseTypeParam && filterData?.tagGroups) {
            const grp = filterData?.tagGroups?.find(item=>item.code==='intended_use');
            const { newValues, id, groupTagMap, selectedGroupTags } = prepareToggleTagFilter(intendedUseTypeParam, grp);

            newOpenDropdowns = {
                ...newOpenDropdowns,
                ['intended use']: true,
            }

            newFilters = {
                ...newFilters,
                tags: [...(newFilters.tags || []), ...newValues],
            }

            if (newValues.length) {
                newFilterView = [
                    ...newFilterView.filter(f => f.id !== id),
                    {
                        id: id,
                        label: grp.name,
                        value: selectedGroupTags
                        .map(code => `${groupTagMap[code]}`)
                        .join(", ")
                    },
                ];
            } else {
                newFilterView = [
                    ...newFilterView.filter(f => f.id !== id),
                ];
            }
        }

        if(hassampleParam || vendorsParam || brandValuesParam || defaultSubCategory || categoryParam || brandsParam || priceRangeParam || animalTypeParam || lifeStageAgeParam || specialtyDietParam || sizeBreedParam || intendedUseTypeParam){
            setfiltersView(newFilterView)
            setFilters(newFilters)
            setOpenDropdowns(newOpenDropdowns)
            setExpandedCategories(newExpandedCategories)
        }
    }, [filterData?.categories, filterData?.tagGroups]);

    // Handle price range from URL parameters separately (only on initial load)
    useEffect(() => {
        const priceRangeParam = searchParams.get('price');
        if (priceRangeParam && filterData?.priceRanges && !filters.priceRange?.length) {
            const {newValues} = preparePriceRangeFilter(priceRangeParam);
            if (newValues.length) {
                setFilters(prev => ({ ...prev, priceRange: newValues }));
                setfiltersView(prev => [
                    ...prev.filter(f => f.id !== 4),
                    { id: 4, label: 'Price Range', value: newValues.map(v => v.label).join(', ') }
                ]);
                setOpenDropdowns(prev => ({ ...prev, priceRange: true }));
            }
        }
    }, [filterData?.priceRanges]);

    // Add effect to ensure tag filter pills show correct values
    useEffect(() => {
        if (filters.tags?.length > 0 && filterData?.tagGroups) {
            filterData.tagGroups.forEach(group => {
                const groupTagCodes = group.tags.map(tag => tag.code);
                const selectedGroupTags = filters.tags.filter(tag => groupTagCodes.includes(tag));
                const groupId = `group-${group.code}`;
                
                if (selectedGroupTags.length > 0) {
                    const groupTagMap = Object.fromEntries(group.tags.map(tag => [tag.code, tag.name]));
                    const uniqueSelectedTags = [...new Set(selectedGroupTags)];
                    const expectedValue = uniqueSelectedTags.map(code => groupTagMap[code]).join(", ");
                    
                    setfiltersView(prev => {
                        const existingIndex = prev.findIndex(f => f.id === groupId);
                        const existingPill = prev[existingIndex];
                        
                        if (!existingPill || existingPill.value !== expectedValue) {
                            const pillData = {
                                id: groupId,
                                label: group.name,
                                value: expectedValue
                            };
                            
                            if (existingIndex >= 0) {
                                return prev.map((f, i) => i === existingIndex ? pillData : f);
                            } else {
                                return [...prev, pillData];
                            }
                        }
                        return prev;
                    });
                }
            });
        }
    }, [filters.tags, filterData?.tagGroups]);

    const toggleDropdown = (dropdownName) => {
        setOpenDropdowns(prev => ({
            ...prev,
            [dropdownName]: !prev[dropdownName]
        }));
    };

    const currentCategory = filters.categories?.[0]?.category_id;

    const yesNoStringToBooleanArray = (value) => {
        if (!value || typeof value !== "string") return [];
        return value
            .split(",")
            .map(v => v.trim().toLowerCase() === "yes");
    }

    const prepareCategoryFilter = (categoryIndex, defaultSubCategory=null) => {
        const categoriesCopy = [...filterData.categories];
        const selectedCategory = categoriesCopy[categoryIndex];
        const categoryCode = selectedCategory.code;

        const matchedCategory = categoriesCopy.find(
            (category) => category?.code === categoryCode
        );

        const subCategoryCodes = matchedCategory?.subCategories?.map(
            (subCategory) => subCategory.code
        ) || [];

        const matchedSubCategorys = matchedCategory?.subCategories?.find(
            (subCategory) => subCategory?.code === defaultSubCategory
        ) || null;

        const updatedCategories = [{ category_id: categoryCode, subcategory: defaultSubCategory ? [defaultSubCategory] : subCategoryCodes   }];
        
        return {updatedCategories, selectedCategory, matchedSubCategorys, categoryCode}
    }

    const prepareBrandFilter = (values) => {
        const incomingValues = Array.isArray(values) ? values : [values];
        const newBrandValues = [];
        const newVendorValues = [];

        incomingValues.forEach(({ id, type }) => {
            const brandExists = filterData?.brands?.some(brand => brand.id === id && brand.type === type);
            if (!brandExists) return;
            
            if (type === "brand") {
                newBrandValues.push(id);
            }

            if (type === "vendor") {
                newVendorValues.push(id);
            }
        });

        const selectedBrandNames = filterData?.brands
            ?.filter(b => (newBrandValues.includes(b.id) && b.type === 'brand'))
            ?.map(b => (b.name || b.id).toString().charAt(0).toUpperCase() + (b.name || b.id).toString().slice(1))
            .join(", ");

        const selectedVendorNames = filterData?.brands
            ?.filter(v => (newVendorValues.includes(v.id) && v.type === 'vendor'))
            ?.map(v => (v.name || v.id).toString().charAt(0).toUpperCase() + (v.name || v.id).toString().slice(1))
            .join(", ");

        return {
            newValues: newBrandValues,
            newVendorValues,
            selectedBrandNames,
            selectedVendorNames
        };
    };

    const prepareBrandValuesFilter = (value) => {
        const incomingValues = typeof value === "string"
            ? value.split(",").map(v => String(v.trim()))
            : [value];

        const newValues = [];
       
        incomingValues.forEach(v => {
            const brandValueExists = filterData?.brandValues?.some(brandValue => brandValue.code === v);
            if (brandValueExists) {
                newValues.push(v);
            }
        });

        const selectedBrandNames = filterData?.brandValues
            .filter(brand => newValues.includes(brand.code))
            .map(brand => brand.name)
            .join(', ');

        return { newValues, selectedBrandNames }
    }

    const preparePriceRangeFilter = (value) => {
        // normalize input to array
        const values = typeof value === "string"
            ? value.split(",").map(v => v.trim())
            : [value];

        let newValues = [...filters.priceRange];

        values.forEach(val => {

            // ----------------------------
            // CASE 1: Custom range (ONLY ONE)
            // ----------------------------
            if (typeof val === "string" && val.includes("-")) {
                const [min, max] = val.split("-").map(Number);
                if (Number.isNaN(min) || Number.isNaN(max)) return;

                setPriceInput({
                    min,
                    max
                })

                // Only create filter if min <= max (valid range)
                if (min <= max) {
                    // remove all predefined
                    newValues = [{
                        id: `${min}-${max}`,
                        label: `$${min} - $${max}`,
                        min,
                        max,
                        type: "custom",
                    }];
                } else {
                    // Invalid range (min > max) - create impossible filter to return no results
                    newValues = [{
                        id: `${min}-${max}`,
                        label: `$${min} - $${max}`,
                        min: min,
                        max: max,
                        type: "custom",
                    }];
                }

                return;
            }

            // ----------------------------
            // CASE 2: Predefined range (MULTIPLE allowed)
            // ----------------------------
            setPriceInput({
                min: '',
                max: ''
            })
            const index = Number(val);
            const range = filterData.priceRanges[index];
            if (!range) return;

            // remove custom if exists
            newValues = newValues.filter(v => v.type !== "custom");

            const exists = newValues.some(v => v.id === index);

            newValues = exists
            ? newValues.filter(v => v.id !== index) // toggle off
            : [
                ...newValues,
                {
                    id: index,
                    ...range,
                    type: "predefined",
                },
                ];
        });
        return { newValues };
    };

    const prepareToggleTagFilter = (value, grp) => {

        const values = typeof value === "string"
            ? value.split(",").map(v => v.trim())
            : [value];

        let newValues = [...filters.tags];

        values.forEach(v => {
        newValues = newValues.includes(v)
            ? newValues.filter(tag => tag !== v)
            : [...newValues, v];
        });
        const id = `group-${grp.code}`;
        const tagsofgroup = filterData.tagGroups.find(group => group.code === grp.code);
        if (!tagsofgroup) return; // safety check
        const groupTagCodes = tagsofgroup.tags.map(tag => tag.code);
        const groupTagMap = Object.fromEntries(tagsofgroup.tags.map(tag => [tag.code, tag.name]));

         // filter only the tags from this group that are selected
        const selectedGroupTags = newValues.filter(val => groupTagCodes.includes(val));

        return { newValues, id, groupTagMap, selectedGroupTags };
    };

    const normalizeToBooleanArray = (value) => {
        if (typeof value === "boolean") {
            return [value];
        }

        if (typeof value === "string") {
            return value
            .split(",")
            .map(v => v.trim().toLowerCase())
            .filter(v => v === "yes" || v === "no" || v === "true" || v === "false")
            .map(v => v === "yes" || v === "true");
        }

        if (Array.isArray(value)) {
            return value
            .filter(v => typeof v === "boolean");
        }

        return [];
    };

    const prepareSampleFilter = (value) => {

        const incomingValues = normalizeToBooleanArray(value);

        const newValues = incomingValues.reduce((acc, curr) => {
        return acc.includes(curr)
            ? acc.filter(v => v !== curr)
            : [...acc, curr];
        }, Array.isArray(filters.sample) ? filters.sample : []);

        const finalval = newValues.map(v => v ? 'Yes' : 'No').toString();

        return { newValues, finalval }
    }

    const toggleCategory = (categoryIndex, defaultSubCategory = null, disableToggle = false) => {
        setExpandedCategories({});

        const categoriesCopy = [...filterData?.categories];
        // const selectedCategory = categoriesCopy[categoryIndex];
        const selectedCategory = categoriesCopy.find(item=> item.code === categoryIndex);
        const categoryCode = selectedCategory.code;

        setExpandedCategories((prevExpanded) => ({
            ...prevExpanded,
            [categoryIndex]: !prevExpanded[categoryIndex],
        }));

        const matchedCategory = categoriesCopy.find(
            (category) => category?.code === categoryCode
        );

        const matchedSubCategorys =
            matchedCategory?.subCategories?.find(
            (subCategory) => subCategory?.code === defaultSubCategory
            ) || null;

        const subCategoryCodes =
            matchedCategory?.subCategories?.map(
            (subCategory) => subCategory.code
            ) || [];

        const isCategoryAlreadySelected = filters.categories?.some(
            (category) => category?.category_id === categoryCode
        );

        let updatedCategories;

        if (disableToggle) {
            updatedCategories = [
                {
                    category_id: categoryCode,
                    subcategory: defaultSubCategory
                    ? [defaultSubCategory]
                    : subCategoryCodes,
                },
            ];
        } else {
            updatedCategories = isCategoryAlreadySelected
            ? filters.categories.filter(
                (category) => category?.category_id !== categoryCode
                )
            : [
                {
                    category_id: categoryCode,
                    subcategory: defaultSubCategory
                    ? [defaultSubCategory]
                    : subCategoryCodes,
                },
                ];
        }

        if (updatedCategories.length) {
            setfiltersView((prev) => [
            ...prev.filter((f) => f.id !== 1),
            {
                id: 1,
                label: "Category",
                value: `${selectedCategory.name}${
                defaultSubCategory && matchedSubCategorys?.name
                    ? `/${matchedSubCategorys.name}`
                    : ""
                }`,
            },
            ]);
        } else {
            setfiltersView((prev) => prev.filter((f) => f.id !== 1));
        }

        setFilters({
            ...filters,
            categories: updatedCategories,
        });
        if (updatedCategories.length) {
            setSearchParams((prev) => {
                const params = {
                    ...Object.fromEntries(prev),
                    category: categoryCode
                };
                if (matchedSubCategorys?.code) {
                    params.subcategory = matchedSubCategorys.code;
                } else {
                    delete params.subcategory;
                }
                return params;
            });
        } else {
            setSearchParams(prev => {
                const params = Object.fromEntries(prev);
                delete params.category;
                delete params.subcategory;
                return params;
            });
        }
    };


    const toggleSubCategory = (categoryId, subCategoryId) => {
        const matchedCategory = filterData?.categories.find(
            (category) => category?.code === categoryId
        );
        const matchedSubCategorys = matchedCategory?.subCategories?.find(
            (subCategory) => subCategory?.code === subCategoryId
        ) || [];
        const updatedCategories = filters.categories.map((category) =>
            category.category_id === categoryId
                ? {
                    ...category,
                    subcategory: [subCategoryId], // Replace with the new selected sub-category
                }
                : category
        );

        setfiltersView(prev => [
            ...prev.filter(f => f.id !== 1), // avoid duplicates by removing existing with id:1
            { id: 1, label: 'Category', value: matchedCategory.name + '/' + matchedSubCategorys.name }
        ]);


        setFilters({
            ...filters,
            categories: updatedCategories,
        });

        if(updatedCategories?.length){
            setSearchParams(prev => {
                const params = {
                    ...Object.fromEntries(prev),
                    subcategory: matchedSubCategorys?.code
                };
                return params;
            });
        } else {
            setSearchParams(prev => ({
                ...Object.fromEntries(prev),
                subcategory: '',
            }));
        }
    };

    const toggleBrandValue = (value) => {
        const newValues = filters.brandValues?.includes(value)
            ? filters.brandValues.filter(v => v !== value)
            : [...filters.brandValues, value];
        const selectedBrandNames = filterData?.brandValues
            .filter(brand => newValues.includes(brand.code))
            .map(brand => brand.name)
            .join(', ');
        // Update filtersView
        if (newValues.length) {
            // Update filtersView only if something is selected
            setfiltersView(prev => [
                ...prev.filter(f => f.id !== 2),
                { id: 2, label: 'Brand Values', value: selectedBrandNames }
            ]);
        } else {
            // Remove brand filter if no values selected
            setfiltersView(prev => prev.filter(f => f.id !== 2));
        }

        setSearchParams(prev => {
            const params = Object.fromEntries(prev);
            if (newValues.length) params.brand_values = newValues.join(',');
            else delete params.brand_values;
            return params;
        });

        setFilters({ ...filters, brandValues: newValues });
    };
    /* A row in the brand list is either a brand or a vendor, and the two are
       keyed separately: a multi-brand store's vendors live in
       `filters.vendorValues` and its brands in `filters.brandValues`, and the id
       spaces overlap — testing membership without `type` ticks the wrong row. */
    const isBrandChosen = (item) => (
        item?.type === 'vendor'
            ? !!filters.vendorValues?.includes(item.id)
            : !!filters.brandValues?.includes(item.id)
    );

    const toggleBrand = (value) => {
        const incomingValues = Array.isArray(value) ? value : [value];

        const newBrandValues = [...filters.brandValues];
        const newVendorValues = [...filters.vendorValues];

        incomingValues.forEach(({ id, type }) => {
            if (type === "brand") {
                const index = newBrandValues.indexOf(id);
                index > -1
                    ? newBrandValues.splice(index, 1)
                    : newBrandValues.push(id);
            }

            if (type === "vendor") {
                const index = newVendorValues.indexOf(id);
                index > -1
                    ? newVendorValues.splice(index, 1)
                    : newVendorValues.push(id);
            }
        });

        const selectedBrandNames = filterData?.brands
            ?.filter(b => (newBrandValues.includes(b.id) && b.type === 'brand'))
            ?.map(b => (b.name || b.id).toString().charAt(0).toUpperCase() + (b.name || b.id).toString().slice(1))
            .join(", ");

        const selectedVendorNames = filterData?.brands
            ?.filter(v => (newVendorValues.includes(v.id) && v.type === 'vendor'))
            ?.map(v => (v.name || v.id).toString().charAt(0).toUpperCase() + (v.name || v.id).toString().slice(1))
            .join(", ");

        // Update filtersView
        if (newBrandValues.length || newVendorValues.length) {
            setfiltersView(prev => [
                ...prev.filter(f => f.id !== 2),
                { id: 2, label: 'Brand', value: `${selectedBrandNames}${selectedVendorNames ?`${selectedBrandNames?.length ? `, ` :``} ${selectedVendorNames}`: ``}` }
            ]);
        } else {
            // Remove brand filter if no values selected
            setfiltersView(prev => prev.filter(f => f.id !== 2));
        }

        setSearchParams(prev => {
            const params = Object.fromEntries(prev);
            if (newBrandValues.length) params.brands = newBrandValues.join(',');
            else delete params.brands;
            if (newVendorValues.length) params.vendors = newVendorValues.join(',');
            else delete params.vendors;
            return params;
        });

        setFilters({ ...filters, brandValues: newBrandValues, vendorValues: newVendorValues });
    };
    const toggleDiscount = (value) => {
        const newValues = filters.discounts.includes(value)
            ? filters.discounts.filter(v => v !== value)
            : [...filters.discounts, value];
        setFilters({ ...filters, discounts: newValues });
    };
    const togglePriceRange = (value) => {
        
        const {newValues} = preparePriceRangeFilter(value);

        if (newValues.length) {
            // Update filtersView only if something is selected
            setfiltersView(prev => [
                ...prev.filter(f => f.id !== 4), // Avoid duplicates by removing existing with id:4
                { id: 4, label: 'Price Range', value: newValues.map(v => v.label).join(', ') }
            ]);
        } else {
            // Remove brand filter if no values selected
            setfiltersView(prev => prev.filter(f => f.id !== 4));
        }
        setFilters({ ...filters, priceRange: newValues });

        setSearchParams(prev => ({
            ...Object.fromEntries(prev),
            price: newValues?.map(item=>item.id)?.join(","),
        }));
    }; 

    const toggleTagValue = (value, grp) => {
        console.log("value, grp",value, grp)
        const newValues = filters.tags?.includes(value)
            ? filters.tags.filter(v => v !== value)
            : [...filters.tags, value];

        setFilters({ ...filters, tags: newValues });

        const id = `group-${grp.code}`;
        const tagsofgroup = filterData.tagGroups.find(group => group.code === grp.code);

        if (!tagsofgroup) return; // safety check

        const groupTagCodes = tagsofgroup.tags.map(tag => tag.code);
        const groupTagMap = Object.fromEntries(tagsofgroup.tags.map(tag => [tag.code, tag.name]));
        // filter only the tags from this group that are selected
        const selectedGroupTags = newValues.filter(val => groupTagCodes.includes(val));

        if (selectedGroupTags.length > 0) {
            // Update filtersView only if something from this group is selected
            setfiltersView(prev => [
                ...prev.filter(f => f.id !== id), // remove only for this group
                {
                    id: id, // unique per group
                    label: grp.name,
                    value: selectedGroupTags
                        .map(code => `${groupTagMap[code]}`)
                        .join(", ")
                }
            ]);
        } else {
            // Remove this group filter if no values selected
            setfiltersView(prev => prev.filter(f => f.id !== id));
        }

        setSearchParams(prev => {
            const params = Object.fromEntries(prev);
            if (selectedGroupTags.length) params[grp.code] = selectedGroupTags.join(',');
            else delete params[grp.code];
            return params;
        });
    };
    const toggleSample = (value) => {
        const newValues = filters?.sample?.includes(value)
            ? filters?.sample?.filter(v => v !== value)
            : [...filters.sample, value];
        setFilters({ ...filters, sample: newValues });
        const finalval = newValues.map(v => v ? 'Yes' : 'No').toString();
        if (newValues.length) {
            // Update filtersView only if something is selected
            setfiltersView(prev => [
                ...prev.filter(f => f.id !== 3), // Avoid duplicates by removing existing with id:3
                { id: 3, label: 'Sample', value: finalval }
            ]);
        } else {
            // Remove brand filter if no values selected
            setfiltersView(prev => prev.filter(f => f.id !== 3));
        }

        setSearchParams(prev => {
            const params = Object.fromEntries(prev);
            if (newValues.length) params.hassample = finalval;
            else delete params.hassample;
            return params;
        });
    };


    /* The category group is navigation once a shopper is inside one. With no
       category chosen it is a flat list of checkboxes; with exactly one chosen it
       becomes where you ARE: a back link out, then the product types inside it.

       SP-main made this change on 2026-09-03, after the rail listed all 17
       categories with one ticked so the breadcrumb, heading, applied chip and a
       ticked box all said "Dental" while 16 rows existed only to leave. It is
       Chewy's model: subcategories are navigation, not refinement.

       The accepted cost: switching category is two clicks rather than one, and
       two categories cannot be held at once.

       One product type is not a choice — a lone subcategory selects everything
       already on screen, so the list collapses to the back link. */
    const liveCategories = (filterData?.categories || []).filter((c) => c?.count > 0);
    const navCategory = filters.categories?.length === 1
        ? liveCategories.find((c) => c.code === filters.categories[0]?.category_id)
        : null;
    const navSubs = (navCategory?.subCategories || []).filter((s) => s?.count > 0);
    const chosenSubs = filters.categories?.[0]?.subcategory || [];

    return (
        <div className="w-full flex-shrink-0">
            {!filterData?.categories ? <RailSkeleton groups={5} /> :
                <>
                    {/* Category. The heading stays "Category" when you drill in;
                        reading the category's own name is the exact duplication
                        this pattern avoids. SP-main titles this group
                        `g.child.title || g.title`, never the chosen value —
                        where you are is the breadcrumb's job. */}
                    {filterData?.categories && (
                        <Accordion
                            title="Category"
                            isOpen={navCategory ? true : openDropdowns.category}
                            onToggle={() => toggleDropdown("category")}
                        >
                            {navCategory ? (
                                <>
                                    {/* The label is declared, never derived:
                                        'All ' + title.toLowerCase() produced
                                        "All category" upstream. */}
                                    <button
                                        type="button"
                                        className="br-navback"
                                        onClick={() => toggleCategory(navCategory.code)}
                                    >
                                        <ChevronLeft aria-hidden="true" />
                                        All categories
                                    </button>

                                    {navSubs.length > 1 && navSubs.map((sub) => (
                                        <button
                                            type="button"
                                            key={sub.code}
                                            className={`br-nav${chosenSubs.includes(sub.code) ? ' on' : ''}`}
                                            onClick={() => toggleSubCategory(navCategory.code, sub.code)}
                                        >
                                            {sub.name}
                                        </button>
                                    ))}
                                </>
                            ) : (
                                <ShowMore
                                    items={liveCategories}
                                    limit={searchParamsCategoryIndex}
                                    isChosen={(item) => !!filters.categories?.some(
                                        (c) => c?.category_id === item.code
                                    )}
                                    renderItem={(item) => (
                                        <Checkbox
                                            key={item.code}
                                            label={item.name}
                                            clamp
                                            count={item.count}
                                            checked={!!filters.categories?.some(
                                                (c) => c?.category_id === item.code
                                            )}
                                            onChange={() => toggleCategory(item.code)}
                                        />
                                    )}
                                />
                            )}
                        </Accordion>
                    )}

                    {/* Brand */}
                    {filterData?.brands && (
                        <Accordion
                            title="Brand"
                            isOpen={openDropdowns.brand}
                            onToggle={() => toggleDropdown("brand")}
                        >
                            {/* A long brand list needs its own search, and it is
                                the rail's search control rather than the app's
                                generic input, so the two searches on this page do
                                not read as different controls. */}
                            <SearchInput
                                value={searchTerm}
                                placeholder="Search brands"
                                onChange={setSearchTerm}
                            />

                            <ShowMore
                                items={filterData.brands.filter((b) =>
                                    b.name.toLowerCase().includes(searchTerm.toLowerCase())
                                )}
                                limit={6}
                                isChosen={(item) => isBrandChosen(item)}
                                renderItem={(item) => (
                                    <Checkbox
                                        key={`${item.type}-${item.id}`}
                                        label={item.name}
                                        clamp
                                        checked={isBrandChosen(item)}
                                        onChange={() => toggleBrand(item)}
                                    />
                                )}
                            />
                        </Accordion>
                    )}

                    {filterData?.brandValues && (
                        <FacetGroup
                            title="Brand Values"
                            isOpen={openDropdowns['brand values']}
                            onToggle={() => toggleDropdown("brand values")}
                            options={filterData.brandValues.map((bv) => ({
                                label: bv.name,
                                value: bv.code,
                            }))}
                            chosen={filters.brandValues}
                            onChange={toggleBrandValue}
                        />
                    )}

                    {filterData?.hasSample && (
                        <FacetGroup
                            title="Samples Available"
                            isOpen={openDropdowns['samples available']}
                            onToggle={() => toggleDropdown("samples available")}
                            options={filterData.hasSample}
                            chosen={filters.sample}
                            onChange={toggleSample}
                        />
                    )}

                    {/* Price range */}
                    {filterData?.priceRanges && (
                        <Accordion
                            title="Price Range"
                            isOpen={openDropdowns.priceRange}
                            onToggle={() => toggleDropdown("priceRange")}
                        >
                            {/* Bands as well as a typed range: a shopper does not
                                know what things cost before they look, so the
                                bands let them answer without knowing and the
                                fields stay for anyone who does. */}
                            <div className="br-price">
                                <Input
                                    label="Minimum price"
                                    hideLabel
                                    type="number"
                                    min="0"
                                    name="min"
                                    value={priceInput.min}
                                    onChange={handlePriceInputChange}
                                    placeholder="$ Min"
                                />
                                <span aria-hidden="true">&ndash;</span>
                                <Input
                                    label="Maximum price"
                                    hideLabel
                                    type="number"
                                    min="0"
                                    name="max"
                                    value={priceInput.max}
                                    onChange={handlePriceInputChange}
                                    placeholder="$ Max"
                                />
                            </div>

                            <div className="br-bands">
                                {filterData?.priceRanges?.map((item, index) => (
                                    <Checkbox
                                        key={item.label ?? index}
                                        label={item.label}
                                        checked={!!filters.priceRange.find((r) => r.id === index)}
                                        onChange={() => togglePriceRange(index)}
                                    />
                                ))}
                            </div>
                        </Accordion>
                    )}

                    {/* Tag groups — the vertical's own set (facetGroups.js) */}
                    {filterData?.tagGroups
                        .filter(tagGroupFilter(storeDetails?.user?.business_vertical?.code))
                        .filter((group) => {
                            const categoryTags = categotyTagmap?.[currentCategory];
                            return !categoryTags || categoryTags.includes(group.code);
                        })
                        .map((group) => (
                            <FacetGroup
                                key={group.code}
                                title={group.name}
                                isOpen={openDropdowns[`${group.name?.toLowerCase()}`]}
                                onToggle={() => toggleDropdown(`${group.name?.toLowerCase()}`)}
                                options={group.tags.map((tag) => ({
                                    label: tag.name,
                                    value: tag.code,
                                }))}
                                chosen={filters.tags}
                                onChange={(value) => toggleTagValue(value, group)}
                            />
                        ))}
                </>
            }
        </div>
    );
}

/* One accordion of plain checkbox options — every group that is not Category,
   Brand or Price. Replaces `FilterDropDown`, which shipped its own copy of the
   group chrome and checkbox markup. */
const FacetGroup = ({ title, options, chosen, onChange, isOpen, onToggle }) => (
    <Accordion title={title} isOpen={isOpen} onToggle={onToggle}>
        <ShowMore
            items={options}
            limit={6}
            isChosen={(item) => !!chosen?.includes(item.value)}
            renderItem={(item) => (
                <Checkbox
                    key={item.value}
                    label={item.label}
                    clamp
                    checked={!!chosen?.includes(item.value)}
                    onChange={() => onChange(item.value)}
                />
            )}
        />
    </Accordion>
);

export default SideFilter;
